import {withTranslation} from "react-i18next";
import React, {useEffect, useRef, useState} from "react";
import {Avatar, Button, Fade, IconButton, makeStyles, Modal, Snackbar, Typography} from '@material-ui/core';
import {useDispatch, useSelector} from "react-redux";
import {poolActions} from "../../../redux/actions/poolActions";
import {walletActions} from "../../../redux/actions/walletActions";
import {roundingDown} from "../../../utils/RoundingDown";
import {addLiquidity} from '../../../utils/Sign'
import CustomTextField from '../../CommonElements/CustomTextField'
import CloseIcon from "@material-ui/icons/Close";
import {getIcons} from "../../../utils/Common";
import i18n from '../../../i18n';
const poolPopTopBG = 'https://cdn.swapallapp.com/l2/images/poolPopTopBG.png'
const checkBoxChecked = 'https://cdn.swapallapp.com/l2/images/CheckBoxChecked.png'
const checkBoxUnchecked = 'https://cdn.swapallapp.com/l2/images/checkBoxUnchecked.png'

const confirmIcon = 'https://demobanner.api-sands.com/Icons/swapIcon.png'

const AddLiquidity = (props) => {
    const {
        onCancel: handleClose,
        modalVisible,
        values,
        address,
        chainId,
        network,
        web3,
        t,
        currentWallet
    } = props;
    const [amount1, setAmount1] = React.useState("");
    const [amount2, setAmount2] = React.useState("");
    const amount1All = useRef(false);
    const amount2All = useRef(false);
    const [inputFocused, setInputFocused] = React.useState(false)
    const [resultViewVisible, setResultViewVisible] = useState(false);
    const [riskViewVisible, setRiskViewVisible] = useState(values.tokenReward === "SATO");
    const [submitDisable, setSubmitDisable] = React.useState(true);
    const [snackBarVisible, setSnackBarVisible] = React.useState(false);
    const [amount1Warning, setAmount1Warning] = React.useState('');
    const [amount2Warning, setAmount2Warning] = React.useState('');
    const [isLpLocked, setIsLpLocked] = React.useState(false);
    const useStyles = makeStyles((theme) => ({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',


        },
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        }
    }));
    const classes = useStyles();
    const { addLiquidityQuote, addLiquidityQuoteLoading, poolSigning } = useSelector(state => state.pool)
    const { userCapitals, tokenIcons } = useSelector(state => state.wallet)
    const { token } = useSelector(state => state.auth)
    const dispatch = useDispatch();

    const coinFree1 = userCapitals.find(item => item.token === values.token1);
    const coinFree2 = userCapitals.find(item => item.token === values.token2);
    useEffect(() => {
        // dispatch(poolActions.addLiquidityQuote({
        //     poolId: values.poolId,
        //     token: values.token1,
        //     amount: '0',
        //     accessToken:token
        // }))
        dispatch(poolActions.clearAddQuote())
        dispatch(walletActions.getUserCapital(token))
        return () => {
        }
    }, [])

    useEffect(() => {
        if (!inputFocused && amount1 > 0 && amount2 > 0 && (coinFree1 && coinFree2) && amount1 <= coinFree1.free && amount2 <= coinFree2.free) {
            setSubmitDisable(false)
        } else {
            setSubmitDisable(true)
        }
        if (amount1 <= 0 && amount1 != "") {
            setAmount1Warning(t('invalidInput'))
        } else if ((!coinFree1 || amount1 > coinFree1.free) && amount1 != "") {
            setAmount1Warning(t('insufficient_fund'))
        } else {
            setAmount1Warning("")
        }
        if (amount2 <= 0 && amount2 != "") {
            setAmount2Warning(t('invalidInput'))
        } else if ((!coinFree2 || amount2 > coinFree2.free) && amount2 != "") {
            setAmount2Warning(t('insufficient_fund'))
        } else {
            setAmount2Warning("")
        }
        if (amount1All.current) {
            amount1All.current = false;
            dispatch(poolActions.addLiquidityQuote({
                poolId: values.poolId,
                token: values.token1,
                amount: amount1,
                accessToken: token
            }))
        } else if (amount2All.current) {
            amount2All.current = false;
            dispatch(poolActions.addLiquidityQuote({
                poolId: values.poolId,
                token: values.token2,
                amount: amount2,
                accessToken: token
            }))
        }
        return () => {
        }
    }, [amount1, amount2, userCapitals])

    useEffect(() => {
        dispatch(walletActions.getUserCapital(token))
        if (addLiquidityQuote.token === values.token1) {
            setAmount1(roundingDown(addLiquidityQuote.amount, 8))
        } else if (addLiquidityQuote.token === values.token2) {
            setAmount2(roundingDown(addLiquidityQuote.amount, 8))
        } else {
            setAmount1("")
            setAmount2("")
        }
        return () => {
        }
    }, [addLiquidityQuote])

    const handleSubmit = async () => {
        setResultViewVisible(true)
        await (addLiquidity)(address, chainId, currentWallet, web3, dispatch, poolSigning, isLpLocked, values.token1, values.token2, amount1, amount2, setAmount1, setAmount2, token, handleClose, setSnackBarVisible)
        setResultViewVisible(false)
    }

    const handleChange = (event) => {
        if (event.target.name === "amount1") {
            setAmount1(event.target.value)
        } else if (event.target.name === "amount2") {
            setAmount2(event.target.value)
        }
    };
    const riskViewBody = (
        <div className={classes.paper}>
            <Typography>
                SATO 项目风险提示
            </Typography>
            <Button
                variant="outlined"
                onClick={() => {
                    setRiskViewVisible(false)
                }}
            >
                我已知晓
            </Button>
            <Button
                variant="outlined"
                onClick={() => {
                    setRiskViewVisible(false)
                    handleClose()
                }}
            >
                暂不参与
            </Button>
        </div>
    );

    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarVisible(false);
    };

    const resultViewBody = (
        <div style={{
            backgroundColor: '#F5F5F5', borderRadius: 24, width: 480, overflow: 'hidden', outline: 0, display: 'flex', alignItems: 'center', flexDirection: 'column'
        }}>

            <Avatar src={confirmIcon} variant="square" style={{ height: 54 * 1.2, width: 77 * 1.2, marginTop: 24 }} />

            <Typography style={{ fontSize: 16, fontWeight: 'bold', marginTop: 8, color: '#251CFF' }}>
                {t('pool-confirm-title')}
            </Typography>
            <Typography style={{ fontSize: 12, fontWeight: 'bold', marginTop: -4, color: '#363636' }}>
                {t('pool-confirm-content')}
            </Typography>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '89%', marginTop: 40 }}>
                <Typography style={{ fontSize: 14, color: '#8786A7', fontWeight: 'bold' }}>
                    {t('pool-addLiquidity')}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar alt="Travis Howard" src={getIcons(values.token1, tokenIcons, true)} style={{ height: 20, width: 20, }} />
                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold', marginRight: 8 }} >
                        {amount1 + " " + values.token1}
                    </Typography>

                    <Avatar alt="Travis Howard" src={getIcons(values.token2, tokenIcons, true)} style={{ height: 20, width: 20, }} />
                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                        {amount2 + " " + values.token2}
                    </Typography>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '89%' }}>
                <Typography style={{ fontSize: 14, color: '#8786A7', fontWeight: 'bold' }}>
                    {t('price')}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                        1 {values.token1} = {roundingDown(addLiquidityQuote.ratioPerToken1ToToken2, 8)} {values.token2}
                    </Typography>


                </div>
            </div>

            {isLpLocked ?
                [
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '89%' }}>
                        <Typography style={{ fontSize: 14, color: '#8786A7', fontWeight: 'bold' }}>
                            {t('pool-poolShare')}
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                {roundingDown(addLiquidityQuote.shareOfPool * 100, 8)}%
                            </Typography>
                        </div>
                    </div>,
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '89%', marginBottom: 40 }}>
                        <Typography style={{ fontSize: 14, color: '#8786A7', fontWeight: 'bold' }}>
                            {t('pool-addLiquidity-lockedDays')}
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                60 {t('pool-addLiquidity-days')}
                            </Typography>
                        </div>
                    </div>,
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 8, width: '89%', marginBottom: 40 }}>
                        <Typography style={{ fontSize: 12, fontWeight: 'bold', color: '#8786A7', textAlign: 'center' }}>
                            {t('pool-addLiquidity-lockedAnnounce')}
                        </Typography>
                    </div>
                ]

                :
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '89%', marginBottom: 40 }}>
                    <Typography style={{ fontSize: 14, color: '#8786A7', fontWeight: 'bold' }}>
                        {t('pool-poolShare')}
                    </Typography>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                            {roundingDown(addLiquidityQuote.shareOfPool * 100, 8)}%
                        </Typography>
                    </div>
                </div>
            }

        </div>
    );


    const addLiquidityBody = (
        <div style={{
            backgroundColor: '#F5F5F5', borderRadius: 24, width: 600, alignItems: 'center', overflow: 'hidden', outline: 0
        }}>
            <div style={{ display: 'flex', flexDirection: 'row',   paddingTop: 40, alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ marginLeft: 24 }}>
                    {/* <Typography style={{ fontSize: 16, fontWeight: 'bold', color: '#251CFF' }}>{t('pool-addLiquidity')}</Typography> */}
                    <Typography style={{ fontSize: 14, fontWeight: 'bold', color: '#251CFF' }}>{values.token1}-{values.token2}</Typography>
                    <Typography style={{ fontSize: 12, fontWeight: '600', color: '#8786A7', marginTop: -4 }}>
                        {t('price')}: 1 {values.token1} = {roundingDown(addLiquidityQuote.ratioPerToken1ToToken2, 8)} {values.token2}
                    </Typography>
                </div>

                <div style={{ flexDirection: 'row', display: 'flex', backgroundColor: 'white', height: 48, alignItems: 'center', width: 100, justifyContent: 'space-between', borderRadius: 24, marginRight: 24 }}>

                    <Avatar src={getIcons(values.token1, tokenIcons, true)} style={{ height: 32, width: 32, marginLeft: 12 }} />

                    <Avatar src={getIcons(values.token2, tokenIcons, true)} style={{ height: 32, width: 32, marginRight: 12 }} />


                </div>
            </div>
            {/* <img src={poolPopTopBG} style={{ width: 400, height: 120, borderTopRightRadius: 24, borderTopLeftRadius: 24, opacity: 0.5 }}>

            </img> */}

            {/* <img src={poolPopBotBG} style={{ width: 591 * 0.6, height: 411 * 0.6, borderTopRightRadius: 24, borderTopLeftRadius: 24, opacity: 0.3, position: 'absolute' }}>

            </img> */}
            <div style={{ marginLeft: 24, marginRight: 24, }}>

                <Typography style={{ fontSize: 16, fontWeight: '600', color: '#251CFF', marginTop: 24 }}>
                    {t('pool-poolShare')}:{roundingDown(addLiquidityQuote.shareOfPool * 100, 8)}%
                </Typography>
                {
                    values.isBoostEnabled ?
                        i18n.language === 'en' ?

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, flexDirection: 'row' }}>
                                <Button
                                    onClick={() => { setIsLpLocked(false) }}
                                    style={{ display: 'flex', width: '48%', backgroundColor: '#010846', height: 60, justifyContent: 'space-between', borderRadius: 16, alignItems: 'center' }}
                                >
                                    <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', marginLeft: 4 }}>
                                        <Typography style={{ fontSize: 12, fontWeight: 'bold', color: 'white' }}>
                                            {t('pool-addLiquidity-1xLock')}
                                        </Typography>
                                        <Typography style={{ fontSize: 8, fontWeight: 'bold', color: '#8786A7', textAlign: 'start' }}>
                                            {t('pool-addLiquidity-1xLockDescription')}
                                        </Typography>
                                    </div>
                                    <Avatar variant="square" src={isLpLocked ? checkBoxUnchecked : checkBoxChecked} style={{ height: 18, width: 18, marginRight: 4 }}></Avatar>

                                </Button>

                                <Button
                                    onClick={() => { setIsLpLocked(true) }}
                                    style={{ display: 'flex', width: '48%', backgroundColor: '#010846', height: 60, justifyContent: 'space-between', borderRadius: 16, alignItems: 'center' }}
                                >

                                    <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'flex-start', marginLeft: 4 }}>
                                        <Typography style={{ fontSize: 12, fontWeight: 'bold', color: 'white' }}>
                                            {t('pool-addLiquidity-3xLock')}
                                        </Typography>
                                        <Typography style={{ fontSize: 8, fontWeight: 'bold', color: '#8786A7' }}>
                                            {t('pool-addLiquidity-3xLockDescription')}
                                        </Typography>
                                    </div>


                                    <Avatar variant="square" src={isLpLocked ? checkBoxChecked : checkBoxUnchecked} style={{ height: 18, width: 18, marginRight: 4 }}></Avatar>

                                </Button>
                            </div>
                            :
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, flexDirection: 'row' }}>
                                <Button
                                    onClick={() => { setIsLpLocked(false) }}
                                    style={{ display: 'flex', width: '48%', backgroundColor: '#010846', height: 60, justifyContent: 'space-between', borderRadius: 16, alignItems: 'center' }}
                                >
                                    <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', marginLeft: 4 }}>
                                        <Typography style={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}>
                                            {t('pool-addLiquidity-1xLock')}
                                        </Typography>
                                        <Typography style={{ fontSize: 10, fontWeight: 'bold', color: '#8786A7', textAlign: 'start' }}>
                                            {t('pool-addLiquidity-1xLockDescription')}
                                        </Typography>
                                    </div>
                                    <Avatar variant="square" src={isLpLocked ? checkBoxUnchecked : checkBoxChecked} style={{ height: 18, width: 18, marginRight: 4 }}></Avatar>

                                </Button>

                                <Button
                                    onClick={() => { setIsLpLocked(true) }}
                                    style={{ display: 'flex', width: '48%', backgroundColor: '#010846', height: 60, justifyContent: 'space-between', borderRadius: 16, alignItems: 'center' }}
                                >

                                    <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'flex-start', marginLeft: 4 }}>
                                        <Typography style={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}>
                                            {t('pool-addLiquidity-3xLock')}
                                        </Typography>
                                        <Typography style={{ fontSize: 10, fontWeight: 'bold', color: '#8786A7' }}>
                                            {t('pool-addLiquidity-3xLockDescription')}
                                        </Typography>
                                    </div>


                                    <Avatar variant="square" src={isLpLocked ? checkBoxChecked : checkBoxUnchecked} style={{ height: 18, width: 18, marginRight: 4 }}></Avatar>

                                </Button>
                            </div>
                        :null
                }

                {/* <div style={{ width: '100%', backgroundColor: 'red', height: 1, marginTop: 24 }}></div> */}
                <div style={{height:24}}/>

                <CustomTextField
                    id="amount1"
                    name="amount1"
                    label={
                        coinFree1 ?
                            t('pool-addLiquidity-enter') + ' ' + values.token1 + ' ' + t('pool-addLiquidity-amount') + "(" + t('pool-addLiquidity-l2Balance') + ":" + roundingDown(coinFree1.free, 4) + " " + values.token1 + ")"
                            :
                            t('pool-addLiquidity-no') + " " + values.token1 + " " + t('pool-addLiquidity-l2Balance')
                    }
                    disabled={addLiquidityQuoteLoading}
                    style={{ width: '100%', textTransform: 'none' }}
                    onChange={handleChange}
                    value={amount1}
                    helperText={amount1Warning}
                    error={amount1Warning !== ''}
                    rightbuttonlabel={t('all')}
                    onrightbuttondisable={inputFocused || addLiquidityQuoteLoading}
                    onrightbuttonclick={() => {
                        amount1All.current = true
                        if (coinFree1) {
                            if (roundingDown(coinFree1.free, 8) != amount1) {
                                setAmount1(roundingDown(coinFree1.free, 8))
                            } else {
                                amount1All.current = false
                            }
                        } else {
                            setAmount1("0")
                        }
                    }}
                    onFocus={() => {
                        setInputFocused(true)
                    }}

                    onBlur={() => {
                        setInputFocused(false)
                        dispatch(poolActions.addLiquidityQuote({
                            poolId: values.poolId,
                            token: values.token1,
                            amount: amount1,
                            accessToken: token
                        }))
                    }}
                    customtype="number"
                >
                </CustomTextField>

                    <div style={{height:40}}/>
                <CustomTextField
                    id="amount2"
                    name="amount2"
                    label={

                        coinFree2 ?
                            t('pool-addLiquidity-enter') + ' ' + values.token2 + ' ' + t('pool-addLiquidity-amount') + "(" + t('pool-addLiquidity-l2Balance') + ":" + roundingDown(coinFree2.free, 4) + " " + values.token2 + ")"
                            :
                            t('pool-addLiquidity-no') + ' ' + values.token2 + ' ' + t('pool-addLiquidity-l2Balance')
                    }
                    disabled={addLiquidityQuoteLoading}
                    style={{ width: '100%', textTransform: 'none' }}
                    onChange={handleChange}
                    value={amount2}
                    helperText={amount2Warning}
                    error={amount2Warning !== ''}
                    rightbuttonlabel={t('all')}
                    onrightbuttondisable={inputFocused || addLiquidityQuoteLoading}
                    onrightbuttonclick={() => {
                        amount2All.current = true
                        if (coinFree2) {
                            if (roundingDown(coinFree2.free, 8) != amount2) {
                                setAmount2(roundingDown(coinFree2.free, 8))
                            } else {
                                amount2All.current = false
                            }
                        } else {
                            setAmount2("0")
                        }
                    }}
                    onFocus={() => {
                        setInputFocused(true)
                    }}
                    onBlur={() => {
                        setInputFocused(false)
                        dispatch(poolActions.addLiquidityQuote({
                            poolId: values.poolId,
                            token: values.token2,
                            amount: amount2,
                            accessToken: token
                        }))
                    }}
                    customtype="number"
                >
                </CustomTextField>

            </div>

            <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column', marginTop: 40, width: '100%' }}>
                <Button
                    // variant="outlined"
                    onClick={handleSubmit}
                    disabled={submitDisable}
                    style={{ backgroundColor: '#251CFF', width: "100%", height: 60, borderRadius: 0, opacity: submitDisable ? 0.5 : 1 }}
                >

                    <Typography style={{ fontSize: 16, fontWeight: 'bold', color: 'white' }}>

                        {t('pool-addLiquidity')}
                    </Typography>

                </Button>


            </div>

            {/* <Typography color="textSecondary" gutterBottom>
                侧链余额:{coinFree1 ? roundingDown(coinFree1.free, 4) : '无'} {values.token1}
            </Typography>
            <TextField
                value={amount1}
                label="输入金额"
                name="amount1"
                // type="number"
                onChange={handleChange}
                helperText={amount1Warning}
                error={amount1Warning !== ''}
                disabled={addLiquidityQuoteLoading}
                InputLabelProps={{
                    shrink: true,
                }}
                inputprops={{
                    inputComponent: NumberFormatCustom,
                    endAdornment: <InputAdornment position="start">
                        <Button
                            variant="outlined"
                            disabled={coinFree1 ? addLiquidityQuoteLoading : true}
                            onClick={() => {
                                amount1All.current = true
                                setAmount1(roundingDown(coinFree1.free, 8))
                            }}
                        >
                            全部
                        </Button>
                        {values.token1}
                    </InputAdornment>,
                }}
                onBlur={() => {
                    dispatch(poolActions.addLiquidityQuote({
                        poolId: values.poolId,
                        token: values.token1,
                        amount: amount1,
                        accessToken: token
                    }))
                }}
            />
            <Typography color="textSecondary" gutterBottom>
                侧链余额: {coinFree2 ? roundingDown(coinFree2.free, 4) : '无'} {values.token2}
            </Typography>



            <TextField
                value={amount2}
                label="输入金额"
                name="amount2"
                onChange={handleChange}
                disabled={addLiquidityQuoteLoading}
                helperText={amount2Warning}
                error={amount2Warning !== ''}
                InputLabelProps={{
                    shrink: true,
                }}
                inputprops={{
                    inputComponent: NumberFormatCustom,
                    endAdornment: <InputAdornment position="start">
                        <Button
                            variant="outlined"
                            onClick={() => {
                                amount2All.current = true
                                setAmount2(roundingDown(coinFree2.free, 8))
                            }}
                            disabled={coinFree2 ? addLiquidityQuoteLoading : true}
                        >
                            全部
                        </Button>
                        {values.token2}
                    </InputAdornment>,
                }}
                onBlur={() => {
                    dispatch(poolActions.addLiquidityQuote({
                        poolId: values.poolId,
                        token: values.token2,
                        amount: amount2,
                        accessToken: token
                    }))
                }}
            /> */}



            {/*确认页*/}
            <Modal
                open={resultViewVisible}
                // open={true}

                onClose={() => {
                    if (!poolSigning) {
                        setResultViewVisible(false)
                    }
                }}
                className={classes.modal}
            >
                {resultViewBody}
            </Modal>
            {/*取消签名提示框*/}
            <Snackbar
                open={snackBarVisible}
                onClose={handleSnackClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                autoHideDuration={5000}
                TransitionComponent={Fade}
                message={t('actionCancelled')}
                key={"cancelSign"}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleSnackClose}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
            {/*风险提示*/}
            {/*<Modal*/}
            {/*    open={riskViewVisible}*/}
            {/*    onClose={()=>{*/}
            {/*        setRiskViewVisible(false)*/}
            {/*    }}*/}
            {/*    className={classes.modal}*/}
            {/*    disableBackdropClick*/}
            {/*>*/}
            {/*    {riskViewBody}*/}
            {/*</Modal>*/}


        </div >
    );

    return (
        <Modal
            open={modalVisible}
            onClose={() => {
                handleClose()
                dispatch(poolActions.clearAddQuote())
            }}
            disableEnforceFocus
            className={classes.modal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"

        >
            {addLiquidityBody}
        </Modal>
    )
}

export default withTranslation()(AddLiquidity);
